export type NumeralProps = {
    value: number;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
}
export const Numeral = (props: NumeralProps) => {
    return <>{`${new Intl.NumberFormat('en', {
        minimumFractionDigits: props.minimumFractionDigits ? props.minimumFractionDigits : 3,
        maximumFractionDigits: props.maximumFractionDigits ? props.maximumFractionDigits : 6,
    }).format(props.value)}`}</>
}